(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* Closed markup is rendered; the open-state markup lives in <template data-pp-open>. */
  function initCollapsibles() {
    document.querySelectorAll('template[data-pp-open]').forEach(function (tpl) {
      var rid = tpl.getAttribute('data-pp-open');
      var closed = document.querySelector('[data-replo-collapsible][data-rid="' + rid + '"]');
      if (!closed) return;
      var closedHTML = closed.outerHTML;
      var openHTML = tpl.innerHTML;
      bind(closed);

      function bind(el) {
        var trigger = el.querySelector('[role="button"]');
        if (!trigger) return;
        trigger.addEventListener('click', function () { toggle(el); });
        trigger.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(el); }
        });
      }

      function swap(el, html) {
        var wrap = document.createElement('div');
        wrap.innerHTML = html;
        var next = wrap.firstElementChild;
        el.replaceWith(next);
        bind(next);
        return next;
      }

      function toggle(el) {
        if (el.getAttribute('data-state') === 'open') {
          var content = el.querySelector('[id][data-state="open"]');
          if (!content) { swap(el, closedHTML); return; }
          content.style.setProperty('--radix-collapsible-content-height', content.scrollHeight + 'px');
          content.classList.add('replo-animated');
          content.setAttribute('data-state', 'closed');
          setTimeout(function () { swap(el, closedHTML); }, 190);
        } else {
          var opened = swap(el, openHTML);
          var c = opened.querySelector('[id][data-state="open"]');
          if (c) {
            c.classList.add('replo-animated');
            c.style.setProperty('--radix-collapsible-content-height', c.scrollHeight + 'px');
          }
        }
      }
    });
  }

  function initGallery() {
    var main = document.querySelector('[data-pp-gallery-main]');
    if (!main) return;
    var thumbs = document.querySelector('[data-pp-gallery-thumbs]');
    var total = main.children.length;
    var index = 0;
    var prev = document.querySelector('[data-replo-part="nav-button"][data-direction="previous"]');
    var next = document.querySelector('[data-replo-part="nav-button"][data-direction="next"]');
    main.style.transition = 'transform 400ms ease';
    if (thumbs) thumbs.style.transition = 'transform 400ms ease';

    function go(i) {
      index = (i + total) % total;
      var w = main.parentElement.getBoundingClientRect().width;
      main.style.transform = 'translate3d(' + (-index * w) + 'px,0,0)';
      if (thumbs) {
        var items = thumbs.children;
        var step = items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 0;
        var viewport = thumbs.parentElement.getBoundingClientRect().width;
        var last = items[items.length - 1];
        var full = last ? last.offsetLeft + last.offsetWidth : 0;
        var offset = Math.max(0, Math.min(index * step, full - viewport));
        thumbs.style.transform = 'translate3d(' + (-offset) + 'px,0,0)';
        Array.prototype.forEach.call(items, function (t, k) {
          var inner = t.firstElementChild;
          if (inner) inner.classList.toggle(inner.getAttribute('data-active-class'), k === index);
        });
      }
      if (prev) prev.style.setProperty('display', index === 0 ? 'none' : 'flex', 'important');
    }

    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(index + 1); });
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(index - 1); });
    if (thumbs) {
      Array.prototype.forEach.call(thumbs.children, function (t, k) {
        t.style.cursor = 'pointer';
        t.addEventListener('click', function () { go(k); });
      });
    }
    var startX = null;
    main.parentElement.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    main.parentElement.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
      startX = null;
    });
    window.addEventListener('resize', function () { go(index); });
    go(0);
  }

  function initBundles() {
    var box = document.querySelector('[data-pp-bundles]');
    if (!box) return;
    box.addEventListener('click', function (e) {
      var bar = e.target.closest('.kaching-bundles__bar');
      if (!bar) return;
      box.querySelectorAll('.kaching-bundles__bar').forEach(function (b) {
        b.classList.toggle('kaching-bundles__bar--selected', b === bar);
      });
    });
  }

  function selectedQuantity() {
    var sel = document.querySelector('[data-pp-bundles] .kaching-bundles__bar--selected');
    return sel ? parseInt(sel.getAttribute('data-qty'), 10) || 1 : 1;
  }

  function addToCart(variantId, quantity, button) {
    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    if (button) button.style.opacity = '0.7';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { alert(res.description || res.message || 'Unable to add to cart'); return; }
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (button) button.style.opacity = ''; });
  }

  function initAddToCart() {
    document.querySelectorAll('[data-pp-atc]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        addToCart(btn.getAttribute('data-variant-id'), selectedQuantity(), btn);
      });
    });
  }

  function initButtons() {
    document.querySelectorAll('#MainContent button, #MainContent [role="button"]').forEach(function (b) {
      if (b.hasAttribute('data-pp-atc') || b.hasAttribute('data-pp-link')) return;
      if (!/BUY NOW/i.test(b.textContent)) return;
      b.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
    document.querySelectorAll('[data-pp-link]').forEach(function (el) {
      el.style.cursor = 'pointer';
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = el.getAttribute('data-pp-link');
      });
    });
  }

  function initStickyBar() {
    var bar = document.querySelector('[data-pp-sticky]');
    if (!bar) return;
    var cls = bar.getAttribute('data-pp-sticky');
    function update() { bar.classList.toggle(cls, window.pageYOffset > 1500); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initShipDate() {
    var d = new Date();
    d.setDate(d.getDate() + 2);
    var label = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    document.querySelectorAll('[data-pp-ship]').forEach(function (el) { el.textContent = label; });
  }

  function initVideos() {
    document.querySelectorAll('[data-pp-video]').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video) return;
      var overlays = wrap.querySelectorAll('[data-pp-video-overlay]');
      function play() {
        overlays.forEach(function (o) { o.style.display = 'none'; });
        video.muted = false;
        video.controls = true;
        video.play();
      }
      overlays.forEach(function (o) { o.style.cursor = 'pointer'; o.addEventListener('click', play); });
    });
  }

  ready(function () {
    initCollapsibles();
    initGallery();
    initBundles();
    initAddToCart();
    initButtons();
    initStickyBar();
    initShipDate();
    initVideos();
  });
})();
